import React, {useCallback, useEffect, useRef, useState} from 'react'


import {MunshiMenu} from "../components/Menu";
import {Card} from "primereact/card";
import {Button} from 'primereact/button';
import {toast, ToastContainer} from 'react-toastify';
import {InputNumber} from "primereact/inputnumber";
import {DropSelect} from "../components/Select/DropSelect";
import {RadioButton} from "primereact/radiobutton";
import {useSpinner} from "../context/SpinnerContext";
import {axiosInstance} from "../utilities/AxiosConfig";
import {PickDateRange} from "../components/Select/DateRangeSelect";
import {ToMySqlDate} from "../utilities/ToMySqlDate";
import dayjs from "dayjs";
import {notify} from "../components/toast";
import {FloatLabel} from "primereact/floatlabel";


export function Post({handle}) {
    const {loading, setLoading} = useSpinner();
    const [action2, setAction2] = useState("All");
    const [target, setTarget] = useState("invoice");
    const [action, setAction] = useState("Post");
    const [initial, setInitial] = useState(0);
    const [final, setFinal] = useState(0);
    const [dates, setDates] = useState(null);
    useEffect(() => {
        setDates([new Date(), new Date()])
    }, [])

    const resetPage = useCallback(() => {
        setLoading(false)
        setTarget("invoice")
        setAction("Post")
        setInitial(0)
        setFinal(0)
        setDates([new Date(), new Date()])
        setAction2("All")
    }, [action, action2, dates, initial, final, target])

    const applyAction = (target, action, initial, final, dates) => {
        if (action === "Post") {
            setLoading(true)
            switch (action2) {
                case "All":
                    axiosInstance.get(`${target}/post/all/`).then((response) => {
                        if (response.data && response.data > 0) {
                            notify(`${response.data} ${target} registered  Successfully`, "success")
                        } else {
                            notify(`No ${target} registered`, "warning")
                        }
                    }).catch((error) => {
                        notify(error.message, "error")
                    }).finally(
                        () => {
                            setLoading(false)
                        })
                    break;
                case "Date":
                    axiosInstance.get(`${target}/post/range/date/${ToMySqlDate(dayjs(dates[0]))}&${ToMySqlDate
                    (dayjs(dates[1]))}`).then((response) => {
                        if (response.data && response.data > 0) {
                            notify(`${response.data} ${target} registered Successfully`, "success")
                        } else {
                            notify(`No ${target} registered`, "warning")
                        }
                    }).catch((error) => {

                        notify(error.message, "error")
                    }).finally(
                        () => {
                            setLoading(false)
                        })
                    break;
                default:
                    axiosInstance.get(`${target}/post/range/reference/${initial}&${final}`).then((response) => {
                        if (response.data && response.data > 0) {
                            notify(`${target} from ${initial} to ${final} registered successfully`, "success")
                        } else {
                            notify(` No ${target} registered`, "warning")
                        }
                    }).catch((error) => {
                        notify(error.message, "error")
                    }).finally(
                        () => {
                            setLoading(false)
                        })
                    break;
            }
        } else if (action === "UnPost") {
            setLoading(true)
            switch (action2) {
                case "All": {
                    axiosInstance.get(`${target}/unPost/all/`).then((response) => {
                        if (response.data && response.data > 0) {
                            notify(`${response.data} ${target} unregistered Successfully`, "success")
                        } else {
                            notify(`None of the ${target}  unregister`, "warning")
                        }
                    }).catch((error) => {
                        notify(error.message, "error")
                    }).finally(
                        () => {
                            setLoading(false)
                        }
                    )
                    break;
                }
                case "Date": {
                    const initDate = ToMySqlDate(dayjs(dates[0]))
                    const finalDate = ToMySqlDate(dayjs(dates[1]))
                    axiosInstance.get(`${target}/unPost/range/date/${initDate}&${finalDate}`).then((response) => {
                        if (response.data && response.data > 0) {
                            notify(`${response.data} of ${target}  from ${initDate} to ${finalDate} has been unregistered Successfully`, "success")
                        } else {
                            notify(`No ${target} unregistered`, "warning")
                        }
                    }).catch((error) => {
                        notify(error.message, "error")
                    }).finally(
                        () => {
                            setLoading(false)
                        }
                    )
                    break;
                }
                default:
                    axiosInstance.get(`${target}/unPost/range/reference/${initial}&${final}`).then((response) => {
                        if (response.data && response.data > 0) {
                            notify(`${response.data} ${target} from ${initial} to ${final} unregistered Successfully`, "success")
                        } else {
                            notify(` No ${target}   unregistered`, "warning")
                        }
                    }).catch((error) => {
                        notify(error.message, "error")
                    }).finally(
                        () => {
                            setLoading(false)
                        }
                    )
                    break;
            }

        }
    }
    const Option2Select = () => {
        return (
            <>
                <div className="card flex justify-content-center mt-2">
                    <div className="flex flex-wrap gap-3">
                        <div className="flex align-items-center">
                            <RadioButton inputId="1" name="action2" value="All"
                                         onChange={(e) => setAction2(e.value)} checked={action2 === 'All'}/>
                            <label htmlFor="1" className="ml-2">All</label>
                        </div>
                        <div className="flex align-items-center">
                            <RadioButton inputId="2" name="action2" value="Date"
                                         onChange={(e) => setAction2(e.value)} checked={action2 === 'Date'}/>
                            <label htmlFor="2" className="ml-2">By Date</label>
                        </div>
                        <div className="flex align-items-center">
                            <RadioButton inputId="2" name="action2" value="Reference"
                                         onChange={(e) => setAction2(e.value)} checked={action2 === 'Reference'}/>
                            <label htmlFor="2" className="ml-2">By Reference</label>
                        </div>

                    </div>
                </div>
            </>
        );
    }
    const OptionSelect = () => {
        return (
            <>
                <div className="card flex justify-content-center mt-2">
                    <div className="flex flex-wrap gap-3">
                        <div className="flex align-items-center">
                            <RadioButton inputId="1" name="action" value="Post"
                                         onChange={(e) => setAction(e.value)} checked={action === 'Post'}/>
                            <label htmlFor="1" className="ml-2">Post</label>
                        </div>
                        <div className="flex align-items-center">
                            <RadioButton inputId="2" name="action" value="UnPost"
                                         onChange={(e) => setAction(e.value)} checked={action === 'UnPost'}/>
                            <label htmlFor="2" className="ml-2">Un-Post</label>
                        </div>

                    </div>
                </div>
            </>
        );
    }

    function MainBody() {
        return (
            <>
                <div className="container flex flex-column justify-content-center align-content-center">
                        <FloatLabel>
                        <DropSelect selectedItem={target} disable={false} id="target"
                                    selectList={[{name: "cashbook"}, {name: "voucher"}, {name: "invoice"}, {name: "purchase"}]}
                                    setItem={setTarget}/>
                            <label htmlFor="target">Transaction Type</label>
                            </FloatLabel>

                    <div className="flex flex-column mt-1">
                        <OptionSelect/>
                        <Option2Select/>
                    </div>
                    <div className="mt-1 container flex flex-row justify-content-around align-content-center">
                    {action2 === "Reference" &&
                        <div className="mt-1 container flex flex-row justify-content-around align-content-center">
                          <FloatLabel>
                            <InputNumber size={13} value={initial} onValueChange={(e) => setInitial(e.value)} id="fr" className="h-2rem mt-2"
                                         locale="en-IN" minFractionDigits={0} disabled={false}/>
                              <label htmlFor="fr">From :</label>
                          </FloatLabel>
                        </div>}
                    {action2 === "Reference" &&
                        <div className="mt-1 container flex flex-row justify-content-around align-content-center">
                            <FloatLabel>
                            <InputNumber size={13} value={final} onValueChange={(e) => setFinal(e.value)} className="h-2rem mt-2" id="fn"
                                         locale="en-IN" minFractionDigits={0} disabled={false}/>
                                <label htmlFor="fn">To :</label>
                            </FloatLabel>
                        </div>}
                    </div>
                    {action2 === "Date" &&
                        <div className="mt-1 container flex flex-row justify-content-around align-content-center mt-2 w-fit">
                            <FloatLabel>
                            <PickDateRange id = "dr" dates={dates} setDates={setDates} disable={false}/>
                                <label htmlFor="dr">Date Range</label>
                            </FloatLabel>
                        </div>}

                </div>
            </>
        )

    }

    const footer = (
        <>
            <div className="container flex justify-content-center">
                <Button label="Proceed" icon="pi pi-sinc mr-1"
                        onClick={() => applyAction(target, action, initial, final, dates)}
                        disabled={action2 !== "All" && ((action2 === "Reference" && (initial === 0 || final === 0 || initial > final) || action2 === "Date" && (dates[0] > dates[1])))}/>
                <Button icon="pi pi-undo" className="ml-1" onClick={resetPage}
                        disabled={false}/>

            </div>
        </>
    );
    if (!loading) {
        return (
            <>
                <ToastContainer autoClose={1000} position="top-right"/>
                <MunshiMenu handle={handle}/>
                <div className="flex flex-column  flex-shrink-1 justify-content-start align-items-center w-full" >
                <div className="flex flex-row flex-shrink-1 justify-content-end align-content-center w-full mt-2">
                    <h1 className="font-bold text-center md:text-left align-self-center mr-4 text-base md:text-4xl  ">Posting/Un-Posting</h1>
                </div>
                <div className="card  flex justify-content-center m-5 w-fit shadow-5 ">
                    <Card title="Posting/Un-Posting" footer={footer}
                          className="flex align-items-center justify-content-center">
                        <MainBody/>
                    </Card>
                </div>
                    </div>
            </>
        );
    }


}

export default Post;

